import { Pipe, PipeTransform } from '@angular/core';

/**
 * This pipe will run the provided function that takes a single argument, and will return
 * the output. If the function is undefined then the default value is passed.
 */
@Pipe({
    name: 'evaluateOrDefault',
    pure: true
})
export class EvaluateOrDefaultPipe<T, R = any> implements PipeTransform {
    transform(value: T, fn?: (input: T) => R, defaultValue?: R): R {
        if (fn == null) {
            return defaultValue;
        } else if (typeof fn === 'function') {
            return fn(value);
        } else {
            throw new Error('Expected a function but got a ' + typeof fn);
        }
    }
}
